import React from 'react';
import { VideoLandingTemplate } from '@/components/landing/landingTemplate';
import { GenerateLandingLinkService } from '@/services';
import { landingMp4ToGifConverterConfig } from '@/data/landingConfig/landingMp4ToGifConverterConfig';
import { AggregateSchema } from '../AggregateSchema';
import { schemaObject_Mp4ToGifConverter } from './schemaObject';

interface Props {}
const Mp4ToGifConverter: React.FC<Props> = () => {
	return (
		<>
			<AggregateSchema schema={schemaObject_Mp4ToGifConverter} />
			<VideoLandingTemplate
				data={landingMp4ToGifConverterConfig}
				funnelLinkService={GenerateLandingLinkService.funnelVideoConverter()}
			/>
		</>
	);
};

export default Mp4ToGifConverter;
